import { Link } from "react-router-dom";
import { Instagram, Phone, MapPin } from "lucide-react";
import { LOGO_URL, INSTAGRAM_URL, PHONE, PHONE_TEL, ADDRESS_LINE, ADDRESS_CITY } from "../../lib/api";

export default function Footer() {
  return (
    <footer className="bg-brand-charcoal text-white/90 pt-16 pb-16" data-testid="public-footer">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src={LOGO_URL} alt="Nails Renss" className="h-12 w-12 rounded-full" />
            <span className="font-display text-2xl font-semibold text-white">Nails Renss</span>
          </div>
          <p className="text-white/60 text-sm max-w-xs leading-relaxed">
            Jouw nagels, jouw stijl. Verzorgde en stijlvolle nagels in Mater, volledig afgestemd op jouw look.
          </p>
          <Link to="/boeken" className="inline-block mt-6 bg-brand-pink text-brand-charcoal font-semibold px-6 py-3 rounded-full hover:bg-white transition-colors" data-testid="footer-book-button">
            BOEK JE AFSPRAAK
          </Link>
        </div>

        <div>
          <h4 className="eyebrow text-brand-pink mb-4">Navigatie</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link to="/" className="hover:text-brand-pink transition-colors">Home</Link></li>
            <li><a href="/#prijslijst" className="hover:text-brand-pink transition-colors">Prijslijst</a></li>
            <li><Link to="/boeken" className="hover:text-brand-pink transition-colors">Boeken</Link></li>
            <li><a href="/#contact" className="hover:text-brand-pink transition-colors">Contact</a></li>
            <li><Link to="/privacybeleid" className="hover:text-brand-pink transition-colors">Privacybeleid</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="eyebrow text-brand-pink mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-2.5">
              <MapPin size={16} className="mt-0.5 text-brand-pink shrink-0" />
              <span>{ADDRESS_LINE}<br />{ADDRESS_CITY}</span>
            </li>
            <li>
              <a href={`tel:${PHONE_TEL}`} className="flex items-center gap-2.5 hover:text-brand-pink transition-colors">
                <Phone size={16} className="text-brand-pink" /> {PHONE}
              </a>
            </li>
            <li>
              <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="flex items-center gap-2.5 hover:text-brand-pink transition-colors">
                <Instagram size={16} className="text-brand-pink" /> @nails.renss
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-6 mt-12 pt-6 border-t border-white/10 text-xs text-white/40 flex flex-col sm:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} Nails Renss — Nagelstudio Mater</span>
        <Link to="/admin/login" className="hover:text-white/70 transition-colors">Beheer</Link>
      </div>
    </footer>
  );
}
